/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {formatPostalCode} from '../../utils/form-utils'

export default function useFooterSubscriptionFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const backgroundColor = 'white'
    const {formatMessage} = useIntl()
    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email',
                id: 'use_footer_subscription_fields.label.email'
            }),
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_footer_subscription_fields.error.required_email'
                }),
                pattern: {
                    /* eslint-disable no-useless-escape */
                    value: /^[\w.%+\-]+@[\w.\-]+\.[\w]{2,6}$/,
                    message: formatMessage({
                        defaultMessage: 'Please match the requested format.',
                        id: 'use_footer_subscription_fields.error.pattern_email'
                    })
                }
            },
            error: errors?.[`${prefix}email`],
            control,
            backgroundColor
        },
        zipCode: {
            name: `${prefix}zipCode`,
            label: formatMessage({
                defaultMessage: 'Zip Code',
                id: 'use_footer_subscription_fields.label.zipCode'
            }),
            defaultValue: '',
            type: 'text',
            autoComplete: 'off',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your zip code.',
                    id: 'use_footer_subscription_fields.error.required_zipCode'
                }),
                pattern: {
                    value: /^\d{5}(-\d{4})?$/,
                    message: formatMessage({
                        defaultMessage:
                            'Please enter a valid zip code. A zip code should contain either 5 digits or 9 digits.',
                        id: 'use_footer_subscription_fields.error.pattern_zipcode'
                    })
                }
            },
            inputProps: ({onChange}) => ({
                onChange(evt) {
                    onChange(formatPostalCode(evt.target.value))
                }
            }),
            error: errors?.[`${prefix}zipCode`],
            control,
            backgroundColor
        }
    }
    return fields
}
